interface Array<T> {
    id(id: number | string): T;
    where<K extends keyof T>(property: K, value: T[K]): Array<T>;
    whereFirst<K extends keyof T>(property: K, value: T[K]): T;
    pushUnique(value: T): boolean;
    remove(value: T): void;
    equals(ary: Array<T>): boolean;
}

//@source https://github.com/Microsoft/TypeScript/issues/29729
type LiteralUnion<T extends U, U = string> = T | (U & { p?: never });

/**
 * Using defineProperty for compatibility reasons with:
 * * ACF (Advanced Custom Fields - Wordpress). 
 * * Wowbook 
 * * etc...
 */
var addArrayFunction = function (name: string, f: any) {
    Object.defineProperty(Array.prototype, name, {
        enumerable: false,
        value: f
    });
}

addArrayFunction("id", function (this: Array<any>, id: number) {
    var l: number = this.length;
    for (var i: number = 0; i < l; ++i)
        if (this[i].id == id)
            return this[i];
    return null;
});

addArrayFunction("where", function (this: Array<any>, property: string, value: any) {
    var l: number = this.length;
    var res = [];
    for (var i: number = 0; i < l; ++i)
        if (this[i][property] == value)
            res.push(this[i]);
    return res;
});

addArrayFunction("whereFirst", function (this: Array<any>, property: string, value: any) {
    var l: number = this.length;
    for (var i: number = 0; i < l; ++i)
        if (this[i][property] == value)
            return this[i];
    return null;
});

addArrayFunction("pushUnique", function (this: Array<any>, value: any): boolean {
    if (this.indexOf(value) >= 0)
        return false;
    this.push(value);
    return true;
});

if (!Array.prototype.indexOf) {
    addArrayFunction("indexOf", function (this: Array<any>, obj: any, start?: number) {
        for (var i = (start || 0), j = this.length; i < j; i++) {
            if (this[i] === obj) { return i; }
        }
        return -1;
    });
}

addArrayFunction("equals", function (this: Array<any>, b: any[]): boolean {
    if (!this && !b)
        return true;
    if (!this && b)
        return false;
    if (this && !b)
        return false;

    if (this.length != b.length)
        return false;

    var l = this.length;
    for (var i = 0; i < l; ++i) {
        if (b.indexOf(this[i]) < 0)
            return false;
    }
    return true;
});

addArrayFunction("remove", function (this: Array<any>, value: any) {
    var idx = this.indexOf(value);
    if (idx < 0)
        return;
    this.splice(idx, 1);
});

//Fix for IE when no console is available (its created when the debug-console opens)
if (!window.console)
    (<any>window)["console"] = { log: function (): void { }, warn: function (): void { } };

namespace e5 {
    export var $ = jQuery;

    $(function () {
        /**
        * Emulate :focus-within
        */
        $("body").on("focus", ".focus-within-container", (e) => {
            var element = e.currentTarget as HTMLElement;
            if (element.classList && !element.classList.contains("focus-within")) {
                element.classList.add("focus-within");
            }
        });

        $("body").on("blur", ".focus-within-container", (e) => {
            var element = e.currentTarget as HTMLElement;
            if (element.classList) {
                setTimeout(() => {
                    if (document.activeElement !== element && !element.contains(document.activeElement as any)) {
                        if (element.classList.contains("focus-within")) {
                            element.classList.remove("focus-within");
                            $(element).trigger("focus-within");
                        }
                    }
                }, 0);
            }
        });
    });
}


